import { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';

interface RequireSuperAdminProps {
  /** Role of the currently logged-in admin (from User state). */
  role?: string;
  children: ReactNode;
  /** Path to redirect to if the user is not a super-admin. */
  fallbackPath?: string;
}

/**
 * Route-level guard for pages that may only be opened by super-admins.
 * Non-super-admins (Portal-Admin, legacy roles) get a redirect to `fallbackPath`
 * — paired with the backend `@RequireRoles(SUPER_ADMIN)` guard for defense in depth.
 */
export function RequireSuperAdmin({
  role,
  children,
  fallbackPath = '/',
}: RequireSuperAdminProps) {
  if (role !== 'super_admin') {
    return <Navigate to={fallbackPath} replace />;
  }
  return <>{children}</>;
}
